export default ({ Vue }) => {
  Vue.config.productionTip = false;
  Vue.config.silent = process.env.VUE_APP_SLIENT;
  Vue.config.errorHandler = function(err, vm, info) {
    console.log("Global Error Handler", err);
  };
};
